// extracted by mini-css-extract-plugin
module.exports = {"tag":"CategoryIcon_tag__2vjpU"};